import PropTypes from 'prop-types'
import PageHeader from 'components/PageHeader'
import SelectBox from 'components/form/SelectBox'
import DocumentFileItem from 'features/document/DocumentFileItem'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { isEmpty } from 'utils'
import { Link, useParams } from 'react-router-dom'
import { CHANNEL_ADD_REFERRER } from 'features/channel/add/hooks/useChannelAddReferrer'
import Loading from 'components/loading/Loading'

const DocumentAddView = ({
  onSelectChannel,
  onSelectReviewDocumentType,
  handleFileUpload,
  handleFileDelete,
  handleDownloadTempFile,
  onClickConfirm,
  onClickCancel,
  readOnly,
}) => {
  const { accountId: adAccountId } = useParams()
  const {
    channels,
    selectedChannel,
    selectedReviewDocumentType,
    reviewDocumentTypes,
    requiredDocumentTypes,
    reviewDocumentsOld,
    uploadDocuments,
    isChannelLoading,
    error,
  } = useSelector(state => state.document.documentAdd)

  const reviewDisplayNames = {
    APPROVED: '심사승인',
    APPROVING: '심사중',
    REJECTED_APPROVAL: '심사보류',
  }

  const from = CHANNEL_ADD_REFERRER.DOCUMENT

  return (
    <>
      <div className="customerfile_wrap">
        <div className="dsp_tit">
          <PageHeader pageTitle="심사서류 관리" />
        </div>
        <div className="ad_managebox">
          <div className="managebox_tit">
            <strong className="tit_box">심사서류 등록</strong>
          </div>
          <table className="tbl_g3">
            <caption className="hide_caption">심사서류 등록 표</caption>
            <colgroup>
              <col />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <div className="inner_tbl">비즈채널 선택</div>
                </th>
                <td>
                  <div className="inner_tbl">
                    {isChannelLoading ? (
                      <Loading />
                    ) : channels && channels.length > 0 ? (
                      <div className="group_select">
                        <SelectBox
                          placeholder="비즈채널을 선택하세요"
                          value={selectedChannel}
                          onValueChange={onSelectChannel}
                          noBlurOnDefault
                          disabled={readOnly}
                          footer={
                            <Link
                              to={`/${adAccountId}/channels/add?from=${from}`}
                              className="link_register">
                              비즈채널 신규 등록하기
                              <span className="img_comm ico_arr" />
                            </Link>
                          }>
                          {channels.map(channel => (
                            <SelectBox.Item
                              key={channel.id}
                              value={channel}
                              text={channel.name}>
                              <span className="limit_line">{channel.name}</span>
                              {channel.siteUrl.mobileUrl && (
                                <span className="txt_addr">
                                  {channel.siteUrl.mobileUrl}
                                </span>
                              )}
                              {channel.siteUrl.pcUrl && (
                                <span className="txt_addr">
                                  {channel.siteUrl.pcUrl}
                                </span>
                              )}
                            </SelectBox.Item>
                          ))}
                        </SelectBox>
                        <SelectBox
                          placeholder="구분"
                          value={selectedReviewDocumentType}
                          onValueChange={onSelectReviewDocumentType}>
                          {reviewDocumentTypes.map(type => (
                            <SelectBox.Item key={type.id} value={type}>
                              {type.desc}
                            </SelectBox.Item>
                          ))}
                        </SelectBox>
                      </div>
                    ) : error ? (
                      <p className="box_error">
                        <span className="ico_comm" />
                        일시적인 문제로 비즈채널을 불러올 수 없습니다.
                        <br />
                        페이지를 새로고침 하세요.
                      </p>
                    ) : (
                      <>
                        <p className="box_error">
                          <span className="ico_comm" />
                          비즈채널이 없습니다.
                        </p>
                        <p className="desc_item">
                          광고자산 관리 &gt; 비즈채널 관리에서{' '}
                          <Link
                            to={`/${adAccountId}/channels/add?from=${from}`}
                            className="fc_emph">
                            신규 비즈채널을 등록
                          </Link>
                          할 수 있습니다.
                        </p>
                      </>
                    )}
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <div className="inner_tbl">심사상태</div>
                </th>
                <td>
                  <div className="inner_tbl">
                    {selectedChannel
                      ? reviewDisplayNames[selectedChannel.reviewStatus]
                      : '-'}
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <div className="inner_tbl">카테고리</div>
                </th>
                <td>
                  <div className="inner_tbl">
                    {selectedChannel
                      ? `${selectedChannel.categoryFullPath}`
                      : '-'}
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <div className="inner_tbl">심사서류</div>
                </th>
                <td>
                  <div className="inner_tbl">
                    {requiredDocumentTypes.length > 0 && (
                      <div className="item_tit">
                        <strong className="tit_detail">
                          해당 카테고리에 필요한 서류를 모두 등록하지 않은 경우
                          비즈채널 심사에서 보류될 수 있습니다.
                          <br />
                          서류첨부시{' '}
                          <strong>
                            불필요한 개인정보(주민등록번호, 카드번호,
                            계좌번호등)가 포함되지 않도록 반드시
                            마스킹(가림처리) 후 첨부
                          </strong>
                          해야 합니다.
                          <br />
                          개인 정보가 포함된 심사서류는 개인 정보 보호를 위해
                          관리자가 임의로 삭제할 수 있습니다.
                        </strong>
                      </div>
                    )}
                    {reviewDocumentsOld.length > 0 && (
                      <div className="group_registdone">
                        <strong className="tit_regist">
                          업로드 완료 파일{' '}
                          <em className="fc_emph">
                            {reviewDocumentsOld.length}
                          </em>
                        </strong>
                        <ul className="list_registdone">
                          {reviewDocumentsOld.map(({ id, filename, url }) => (
                            <li key={id}>
                              <span className="limit_line">{filename}</span>
                              <a
                                href={`${url}&download`}
                                className="btn_download">
                                <span className="ico_comm">다운로드</span>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {requiredDocumentTypes.length > 0 ? (
                      <div className="group_registlist">
                        <strong className="tit_regist">
                          파일당 용량 최대 <em className="fc_warn2">10MB</em>
                        </strong>
                        <ul className="list_document">
                          {requiredDocumentTypes.map(type => (
                            <DocumentFileItem
                              key={type.id}
                              reviewDocumentType={type.name}
                              uploadDocuments={uploadDocuments.filter(
                                f => f.id === type.id
                              )}
                              handleDownloadTempFile={handleDownloadTempFile}
                              handleFileUpload={handleFileUpload(type.id)}
                              handleFileDelete={handleFileDelete}
                            />
                          ))}
                        </ul>
                      </div>
                    ) : (
                      '필요서류가 없습니다.'
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="page_btn">
          <div className="inner_btn">
            <button type="button" className="btn_gb" onClick={onClickCancel}>
              <span className="inner_g">취소</span>
            </button>
            <button
              type="button"
              className={classNames([
                'btn_gb gb_bl',
                { in_active: isEmpty(uploadDocuments) },
              ])}
              onClick={onClickConfirm}>
              <span className="inner_g">확인</span>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default DocumentAddView

DocumentAddView.propTypes = {
  onClickCancel: PropTypes.func.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
  handleFileDelete: PropTypes.func.isRequired,
  handleFileUpload: PropTypes.func.isRequired,
  handleDownloadTempFile: PropTypes.func.isRequired,
  onSelectChannel: PropTypes.func.isRequired,
  onSelectReviewDocumentType: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
}
